import { useEffect, useState, useCallback } from "react";
import { useTranslation } from 'react-i18next';
import axios from "axios"
import authConfig from "../../authConfig";
import { useSelector, useDispatch } from 'react-redux';
import {
    AuthenticatedTemplate,
    UnauthenticatedTemplate,
    useMsal,
    useIsAuthenticated,
    useAccount
} from "@azure/msal-react"

import {
    format,
    subHours,
    startOfMonth,
    endOfMonth,
    formatISO,
    subMonths,
    getYear,
    addMonths,
    parseISO,
    parse,
    toDate
} from 'date-fns';
import { enGB, cy } from 'date-fns/locale';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import InputGroup from 'react-bootstrap/InputGroup';
import Pagination from 'react-bootstrap/Pagination';
import Badge from 'react-bootstrap/Badge';

import SitePage from '../sitepage/SitePage';
import { Link, NavLink, useNavigate } from "react-router-dom";

import CommitteeSelector from '../committee/CommitteeSelector';
//import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';
import MeetingTitleInput from './MeetingTitleInput';

import { DateTimePicker } from '@mui/x-date-pickers';

import { delocalizedIsoDate, isValidDate } from '../Util.js';



function MeetingListPopup(props) {

    const { t, i18n } = useTranslation();
    const language = useSelector((state) => state.language.value);
    const navigate = useNavigate();

    const [show, setShow] = useState(false);

    const [committee, setCommittee] = useState(null);
    const [data, setData] = useState([]);

    const [filterText, setFilterText] = useState("");
    const [page, setPage] = useState(1);
    const pageSize = 10;

    const isAuthenticated = useIsAuthenticated();
    const { instance, accounts } = useMsal()
    const account = useAccount(accounts[0] || {})

    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        setShow(false);
        setData([]);
    }
    const handleShow = () => {
        setShow(true);
        setFilterText("");
        setPage(1);
        loadData();
    }
    const handleSelectCommittee = (o) => {
        setCommittee(o);
    }
    const handleEditClick = (o) => {
        navigate("/meeting/edit/" + o.id);
    }
    const handleOpenClick = (o) => {
        navigate("/meeting/" + o.id);
    }
    function loadData() {
        setError(null)
        setData([])
        if (isAuthenticated) {
            if (account && loading == false) {
                setLoading(true)
                instance
                    .acquireTokenSilent({
                        scopes: authConfig.api.scopes,
                        account: account
                    })
                    .then(response => {
                        if (response) {
                            //console.log("Got access token:", response)
                            axios
                                .create({
                                    headers: { Authorization: `Bearer ${response.accessToken}` }
                                })
                                .get(authConfig.api.urls.getMeetingList + (committee == null ? '' : "?committeeid=" + committee.id))
                                .then(function (response) {
                                    console.log(response.data);
                                    //response.data.agendaItems.sort((a, b) => {
                                    //    return a.positionIndex - b.positionIndex;
                                    //});
                                    setData(response.data);
                                })
                                .catch(function (error) {
                                    setError("Error fetching data: " + error.message)
                                    console.error(error)
                                })
                                .then(function () {
                                    // always executed
                                    setLoading(false)
                                })
                        } else {
                            setError("Empty token??")
                            console.error("no token acquired")
                        }
                    })
                    .catch(error => {
                        setError("Error getting token: " + error.message)
                        console.error(error)
                        setLoading(false)
                    })
            } else {
                setError("No account...")
            }
        } else {
            axios
                .create({
                    /*headers: { Authorization: `Bearer ${response.accessToken}` }*/
                })
                .get(authConfig.api.urls.getMeetingList + (committee == null ? '' : "?committeeid=" + committee.id))
                .then(function (response) {
                    //console.log(response.data);
                    //response.data.agendaItems.sort((a, b) => {
                    //    return a.positionIndex - b.positionIndex;
                    //});
                    setData(response.data);
                })
                .catch(function (error) {
                    setError("Error fetching data: " + error.message)
                    console.error(error)
                })
                .then(function () {
                    // always executed
                    setLoading(false)
                })
        }
    }

    const titleFor = (m) => (language === 'cy' ? m.titleCy : m.titleEn) || m.titleEn;

    const statusVariant = (statusName) => {
        switch ((statusName || '').toLowerCase()) {
            case 'published': return 'success';
            case 'scheduled': return 'primary';
            case 'postponed': return 'warning';
            case 'cancelled': return 'danger';
            case 'new': return 'secondary';
            default: return 'info';
        }
    };

    const filteredData = data.filter((m) => {
        if (!filterText.trim()) return true;
        const needle = filterText.trim().toLowerCase();
        const dateStr = m.start ? format(new Date(m.start), 'dd/MM/yyyy') : '';
        return (titleFor(m) || '').toLowerCase().includes(needle)
            || (m.status && m.status.name ? m.status.name.toLowerCase().includes(needle) : false)
            || dateStr.includes(needle);
    });

    const totalPages = Math.max(1, Math.ceil(filteredData.length / pageSize));
    const currentPage = Math.min(page, totalPages);
    const pagedData = filteredData.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    const maxPageButtons = 10;
    let pageWindowStart = Math.max(1, currentPage - Math.floor(maxPageButtons / 2));
    let pageWindowEnd = Math.min(totalPages, pageWindowStart + maxPageButtons - 1);
    pageWindowStart = Math.max(1, pageWindowEnd - maxPageButtons + 1);
    const pageNumbers = [];
    for (let p = pageWindowStart; p <= pageWindowEnd; p++) {
        pageNumbers.push(p);
    }

    return (
        <>
            <Row>
                <Col xs="8">
                    <CommitteeSelector value={committee} onChange={handleSelectCommittee} />
                </Col>
                <Col xs="4">
                    <Button variant="success" onClick={handleShow} disabled={committee == null}>
                        Open List
                    </Button>
                </Col>
            </Row>
            <Modal show={show} onHide={handleClose} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Meetings for {committee == null ? '' : committee.nameEn}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <InputGroup className="mb-3">
                        <InputGroup.Text>Filter</InputGroup.Text>
                        <Form.Control
                            placeholder="Filter by title or status..."
                            value={filterText}
                            onChange={(e) => { setFilterText(e.target.value); setPage(1); }}
                        />
                        {filterText && (
                            <Button variant="outline-secondary" onClick={() => { setFilterText(""); setPage(1); }}>
                                Clear
                            </Button>
                        )}
                    </InputGroup>

                    <Table bordered hover responsive size="sm" className="align-middle">
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th style={{ width: "110px" }}>Date</th>
                                <th style={{ width: "120px" }}>Status</th>
                                <th style={{ width: "90px" }} className="text-center">Open</th>
                                <th style={{ width: "90px" }} className="text-center">Edit</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pagedData.length === 0 && (
                                <tr>
                                    <td colSpan="5" className="text-center text-muted">
                                        {loading ? 'Loading...' : 'No meetings found'}
                                    </td>
                                </tr>
                            )}
                            {pagedData.map((meeting, index) => (
                                <tr key={meeting.id ?? index} className={index % 2 === 0 ? "" : "table-light"}>
                                    <td>{titleFor(meeting)}</td>
                                    <td>{format(new Date(meeting.start), 'dd/MM/yyyy')}</td>
                                    <td>
                                        <Badge bg={statusVariant(meeting.status.name)}>
                                            {meeting.status.name}
                                        </Badge>
                                    </td>
                                    <td className="text-center">
                                        {meeting.status.name === 'New' ? '' : (
                                            <Button size="sm" variant="primary" onClick={() => handleOpenClick(meeting)}>Open</Button>
                                        )}
                                    </td>
                                    <td className="text-center">
                                        <Button size="sm" variant="outline-secondary" onClick={() => handleEditClick(meeting)}>Edit</Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    {totalPages > 1 && (
                        <div className="d-flex justify-content-between align-items-center">
                            <small className="text-muted">
                                Showing {(currentPage - 1) * pageSize + 1}
                                –{Math.min(currentPage * pageSize, filteredData.length)} of {filteredData.length}
                            </small>
                            <Pagination className="mb-0">
                                <Pagination.First disabled={currentPage === 1} onClick={() => setPage(1)} />
                                <Pagination.Prev disabled={currentPage === 1} onClick={() => setPage(currentPage - 1)} />
                                {pageNumbers.map((p) => (
                                    <Pagination.Item
                                        key={p}
                                        active={p === currentPage}
                                        onClick={() => setPage(p)}
                                    >
                                        {p}
                                    </Pagination.Item>
                                ))}
                                <Pagination.Next disabled={currentPage === totalPages} onClick={() => setPage(currentPage + 1)} />
                                <Pagination.Last disabled={currentPage === totalPages} onClick={() => setPage(totalPages)} />
                            </Pagination>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default MeetingListPopup;